<h4 class="card-title">Data Import</h4>
<div *ngIf="isLoading">
  <div class="preloader-wrapper big active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoading">
<div *ngIf="pageData.viewMode=='UPLOAD'" class="row">
  <div class="row">
    <div class="input-field col s12">
      <i class="material-icons prefix">timer</i>
      <input [(ngModel)]="pageData.sHour" id="txtName" name="txtName" type="number" min="0" max="23" />
      <label for="txtName" class="active">Start Hour</label>
    </div>
    <div class="input-field col s12">
      <i class="material-icons prefix">timer</i>
      <input [(ngModel)]="pageData.eHour" id="txtName" name="txtName" type="number" min="0" max="23" />
      <label for="txtName" class="active">End Hour</label>
    </div>
    <!-- <div class="input-field col s12">
      <i class="material-icons prefix">link</i>
      <input [(ngModel)]="pageData.account.url" id="txtName" name="txtName" type="text" />
      <label for="txtName" class="active">URL</label>
    </div> -->
    <div class="col s12">
      <input type="file" #csvReader name="Upload CSV" id="txtFileUpload" (change)="uploadFile($event)" accept=".csv" />
    </div>
    <div class="col s12 mt-1">
      <button (click)="readCsvRecords()" class="btn cyan waves-effect waves-light" type="submit" name="action">Next
        <i class="material-icons right">send</i>
      </button>
    </div>
  </div>
</div>
<div *ngIf="pageData.viewMode=='RECORDS'">
  <ng-container *ngIf="records.length>0">
    <div class="row">
      <div class="col s12">
        <div class="card-alert card cyan lighten-5">
          <div class="card-content cyan-text">
            <p>Records to Import</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngFor="let rec of records; let i=index;">
      <div class="col s2">{{i+1}}
      </div>
      <div class="col s2">
        {{rec.timestamp}}
      </div>
      <div class="col s4">
        {{rec.sensorId}}
      </div>
      <div class="col s2">
        {{rec.inValue}}
      </div>
      <div class="col s2">
        {{rec.outValue}}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="recordsErr.length>0">
    <div class="row">
      <div class="col s12">
        <div class="card-alert card red lighten-5">
          <div class="card-content red-text">
            <p>Invalid Records</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngFor="let rec of recordsErr; let i=index;">
      <div class="col s2">{{i+1}}
      </div>
      <div class="col s6">
        {{rec.text}}
      </div>
      <div class="col s4">
        {{rec.remark}}
      </div>
    </div>
  </ng-container>
  <div class="mt-1">
    <button (click)="pageData.viewMode='UPLOAD'" class="btn cyan lighten-2 waves-effect waves-light" type="submit" name="action" style="margin-right: 2px;">Cancel
    </button>
    <button (click)="importRecords()" class="btn cyan waves-effect waves-light" type="submit" name="action">Next
      <i class="material-icons right">send</i>
    </button>
  </div>
</div>
<div *ngIf="pageData.viewMode=='STATUS'">
  <div class="row">
    <div class="col s12">
      <div class="card-alert card cyan lighten-5">
        <div class="card-content cyan-text">
          <p>{{pageData.countSuccess}} of {{records.length}} imported!</p>
          <div class="progress">
            <div class="determinate" [style.width.%]="(pageData.countSuccess/records.length)*100"></div>
          </div>
        </div>
      </div>
      <div style="font-style: italic;">
        Pending: {{pageData.countPending}}, Delay: {{pageData.processDelay}}
      </div>
    </div>
  </div>
</div>
<div *ngIf="pageData.viewMode=='FORM'">
  <form class="col s12">
    
    <div class="row">
      <!-- <div class="input-field col s12">
        <i class="material-icons prefix">question_answer</i>
        <textarea id="message3" class="materialize-textarea"></textarea>
        <label for="message3">Message</label>
      </div> -->
      <div class="row">
        <div class="input-field col s12">
          
          <button (click)="userList()" class="btn cyan lighten-2 waves-effect waves-light right" type="submit" name="action" style="margin-right: 2px;">Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
</div>
